import(/* webpackMode: "eager" */ "/vercel/path0/packages/service/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@zapier+design-tokens@2.1.0/node_modules/@zapier/design-tokens/src/css/custom-properties.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@zapier+design-system@9.14.3_@types+react@18.3.18_react-aria-components@1.6.0_react-dom@18.3.1_react@18.3.1/node_modules/@zapier/design-system/dist/style.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@zapier+design-system-beta@2.5.4_@types+react@18.3.18_react-aria-components@1.6.0_react-aria@_ghnmi7mb4g3cmyxoalr6ja7mda/node_modules/@zapier/design-system-beta/dist/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/service/src/components/AppLayout.tsx");
